import React, { Component, Suspense } from "react";
import ContentWrapper from "./../../../../template/Layout/ContentWrapper";
import { Row } from "reactstrap";

import { Tab, Icon } from "semantic-ui-react";
import dataResumen from "../../../../../models/resumenCard";
// import Documents from '../../../Components/Documents';
// import Comments from '../../../Components/Comments';
import { withRouter } from "react-router-dom";
import axios from "axios";
import Loader from "../../../../Global/Loader";
import { Services } from "../../../../../repositories/clients/Services";
import { withNamespaces } from "react-i18next";
const Events = React.lazy(() => import("./Events"));
const Summary = React.lazy(() => import("./Summary"));

class ContainerDetails extends Component {
  state = {
    allSteps: [],
    id: this.props.match.params.id,
    dataResumen: dataResumen,
    dataAlmacenada: [],
    dataContainer: {},
    shipment: [],
    fullLoader: false,
    commentsData: [
      {
        ComType: "Tipo 1",
        ComTypeId: 1,
        Comment: "Comentario de prueba",
        CommentId: 73,
        Date: "2019-06-20",
        Module: "Comentario",
        ModuleId: 1,
        RowId: 861,
        UpdateBy: "API",
      },
      {
        ComType: "Tipo 2",
        ComTypeId: 1,
        Comment: "Comentario de prueba",
        CommentId: 73,
        Date: "2019-07-02",
        Module: "Comentario",
        ModuleId: 1,
        RowId: 861,
        UpdateBy: "API",
      },
    ],
    catalogsData: [
      {
        ComTypeId: 1,
        ModuleId: 1,
        ComType: "Supplier Follow Up",
        value: 1,
        label: "Supplier Follow Up",
      },
      {
        ComTypeId: 2,
        ModuleId: 1,
        ComType: "Order Quality",
        value: 2,
        label: "Order Quality",
      },
      {
        ComTypeId: 3,
        ModuleId: 1,
        ComType: "Order Quantities",
        value: 3,
        label: "Order Quantities",
      },
      {
        ComTypeId: 10,
        ModuleId: 1,
        ComType: "Other",
        value: 10,
        label: "Other",
      },
    ],
    dataTabla: [],
  };

  componentDidMount = () => {
    this.getContainerForId();
  };
  obtenerSteps = (shipment) => {
    var steps = [];
    if (
      shipment.TransportModeCode === "A" ||
      shipment.TransportModeCode === "O"
    ) {
      if (shipment.DirectionCode === "I") {
        steps = this.state.stepsIMPO;
      } else if (shipment.DirectionCode === "E") {
        steps = this.state.stepsEXPO;
      } else if (shipment.DirectionCode === "D") {
        steps = this.state.stepsDOMESTICO;
      }
    } else {
      steps = this.state.stepsTERRESTRE;
    }
    return steps;
  };

  getContainerForId = () => {
    let { stepsGenerico } = this.state;
    axios
      .get(
        `${Services.TRACEABILITY.path}trazabilidad/ContainerDetail/${this.state.id}?userId=${this.props._user}&lang=${this.props.lng}`,
      )
      .then((success) => {
        let dataTabla = success.data.item;
        let newResume = dataResumen.map((f) => {
          f.data.map((g) => {
            g.value = success.data.data[0][g.key];
            g.value2 = success.data.data[0][g.idlink];
            return g;
          });
          return f;
        });

        let dataEvents = success.data.dataEvents;
        let newSteps = success.data.steps;

        // if(dataEvents.length > 0){
        //   newSteps = success.data.steps
        // }
        // else newSteps = stepsGenerico

        this.setState({
          dataResumen: newResume,
          noContenedor: success.data.data[0].ContainerNo,
          dataAlmacenada: success.data.data[0],
          dataTabla,
          steps: newSteps,
          allSteps: dataEvents,
          fullLoader: true,
        });
      })
      .catch((error) => {
        console.warn(error);
      });
  };

  render() {
    let { dataAlmacenada, fullLoader } = this.state;
    return (
      <>
        <Loader hidden={fullLoader} />
        <ContentWrapper>
          <div className="content-heading">
            <span className="icon-container icon-header" />
            {this.props.t("container_detail")}
            <div className="euro-return-tittle">
              <Icon.Group size="large">
                <Icon
                  name="angle left"
                  className="_btnBack"
                  size="big"
                  onClick={() =>
                    this.props.history.push(
                      "/shipments-details/" + dataAlmacenada.ShipmentId,
                    )
                  }
                />
              </Icon.Group>
              <span
                className="label-back"
                onClick={() =>
                  this.props.history.push(
                    "/shipments-details/" + dataAlmacenada.ShipmentId,
                  )
                }
              >
                {this.props.t("back")}
              </span>
            </div>
          </div>

          <Tab
            menu={{
              secondary: true,
              pointing: true,
              className: "custom-tab-menu",
            }}
            menuPosition="right"
            panes={[
              {
                menuItem: this.props.t("summary"),
                render: () => (
                  <Suspense fallback={<div>Loading...</div>}>
                    {" "}
                    <Summary
                      dataTabla={this.state.dataTabla}
                      dataAlmacenada={this.state.dataAlmacenada}
                      steps={this.state.steps}
                      data={this.state.dataResumen}
                    ></Summary>
                  </Suspense>
                ),
              },
              {
                menuItem: this.props.t("events"),
                render: () => (
                  <Suspense fallback={<div>Loading...</div>}>
                    {" "}
                    <Events
                      noContenedor={this.state.noContenedor}
                      doEmbarque={this.state.doEmbarque}
                      steps={this.state.steps}
                      allSteps={this.state.allSteps}
                    ></Events>
                  </Suspense>
                ),
              },
              // { menuItem: 'Comentarios', render: () => <div><Comments data={this.state.commentsData} catalogs={this.state.catalogsData}> </Comments></div> },
              // { menuItem: 'Documentos', render: () => <div><Documents rolId={12} shipment="" shipmentDataPlane=""></Documents></div> },
            ]}
          />
        </ContentWrapper>
      </>
    );
  }
}
export default withNamespaces()(withRouter(ContainerDetails));
